<template>
    <div :class="['app-container', theme]" data-app>
        <header class="navbar">
            <div class="nav-left">
                <button class="mobile-menu-btn" @click="isMenuOpen = !isMenuOpen">☰</button>
                <div class="logo">
                    <img style="width: 40px; height: 35px; cursor: pointer;" @click="irHome()" :src="aciquiLogo" alt="homepage" /> ACIQUI<span>Docs</span>
                </div>  
            </div>
            <button @click="toggleTheme" class="theme-toggle">
                {{ theme === 'light' ? '🌙' : '☀️' }}
            </button>
        </header>

        <div class="layout">
            <div v-if="isMenuOpen" class="overlay" @click="isMenuOpen = false"></div>

            <aside :class="['sidebar', { 'open': isMenuOpen }]">
                <nav>
                    <div v-for="group in estructuraMenu" :key="group.title" class="nav-group">
                        <h4>{{ group.title }}</h4>
                        <ul>
                            <template v-for="item in group.items">
                                <li v-if="item.children" :key="'parent-' + item.id" class="nav-item-parent">
                                    <div class="nav-subtitle-container" @click="toggleGroup(item.id)"
                                        :class="{ 'is-expanded': openGroups.includes(item.id) }">
                                        <span class="nav-subtitle">{{ item.title }}</span>
                                        <span class="chevron">{{ openGroups.includes(item.id) ? '▲' : '▼' }}</span>
                                    </div>

                                    <transition name="slide">
                                        <ul v-if="openGroups.includes(item.id)" class="sub-nav">
                                            <li v-for="sub in item.children" :key="sub.id" style="font-weight: bold;">
                                                <a href="#" :class="{ active: currentView === sub.id }"
                                                    @click.prevent="navigate(sub.id)">
                                                    {{ sub.title }}
                                                </a>
                                            </li>
                                        </ul>
                                    </transition>
                                </li>

                                <li v-else :key="item.id">
                                    <a href="#" :class="{ active: currentView === item.id }"
                                        @click.prevent="navigate(item.id)">
                                        {{ item.title }}
                                    </a>
                                </li>
                            </template>
                        </ul>
                    </div>
                </nav>
            </aside>

            <main class="content">
                <Breadcrumbs :currentSectionName="sectionTitles[currentView] || 'Cargando...'" @navigate="navigate" />

                <transition name="fade" mode="out-in">
                    <component :is="currentView" :key="currentView" />
                </transition>

                <DocPagination :currentView="currentView" :sections="docOrder" @navigate="navigate" />
            </main>
        </div>
    </div>
</template>

<script>
import '@/assets/css/ayuda-styles.css';
import Breadcrumbs from './components/Breadcrumbs.vue';
import DocPagination from './components/DocPagination.vue';

import aciquiLogo from "@/assets/images/aciqui.svg";

export default {
    name: 'AyudaDocs',
    components: {
        Breadcrumbs,
        DocPagination,
        // Carga perezosa (Lazy Loading) de tus vistas
        Introduccion: () => import('./components/Introduccion.vue'),
        Instalacion: () => import('./components/Instalacion.vue'),
        Login: () => import('./components/IniciarSesion.vue'),
        Logout: () => import('./components/CierreSesion.vue'),
        //Monitoreo
        Monitoreo: () => import('./components/Monitoreo/Monitoreo.vue'),
        VerDispositivo: () => import('./components/Monitoreo/VerDispositivo.vue'),
        VerGeocerca: () => import('./components/Monitoreo/VerGeocerca.vue'),
        dispAlaRedonda: () => import('./components/Monitoreo/DispRedonda.vue'),
        //Usuarios
        usuarios: () => import('./components/Usuarios/GestionUsuarios.vue'),
        altaUsuario: () => import('./components/Usuarios/AltaUsuario.vue'),
        EditarUsuario: () => import('./components/Usuarios/EditarUsuario.vue'),
        EstatusUsuario: () => import('./components/Usuarios/EstatusUsuario.vue'),
        RestablecerContraseña: () => import('./components/Usuarios/RestablecerContraseña.vue'),
        CerrarSesion: () => import('./components/Usuarios/CerrarSesiones.vue'),
        //Dispositivos
        Dispositivos: () => import('./components/Dispositivos/ListadoDispositivos.vue'),
        altaDispositivo: () => import('./components/Dispositivos/AltaDispositivo.vue'),
        EditarDispositivo: () => import('./components/Dispositivos/EditarDispositivo.vue'),
        EliminarDispositivo: () => import('./components/Dispositivos/EliminarDispositivo.vue'),
        CompartirLink: () => import('./components/Dispositivos/CompartirLink.vue'),
        //Ubicaciones
        Ubicaciones: () => import('./components/Ubicaciones/Ubicaciones.vue'),
        altaUbicacion: () => import('./components/Ubicaciones/AltaUbicacion.vue'),
        VerUbicaciones: () => import('./components/Ubicaciones/VerUbicaciones.vue'),
        EditarUbicacion: () => import('./components/Ubicaciones/EditarUbicacion.vue'),
        EliminarUbicacion: () => import('./components/Ubicaciones/EliminarUbicacion.vue'),
        //Notificaciones
        Notificaciones: () => import('./components/Notificaciones/Notificaciones.vue'),
        //Alertas
        Alertas: () => import('./components/Alertas/Alertas.vue'),
        AlarmaAudible: () => import('./components/Alertas/AlarmaAudible.vue'),
        //geocercas
        AdminGeocerca: () => import('./components/Geocercas/Geocercas.vue'),
        BusquedaGeocerca: () => import('./components/Geocercas/BusquedaGeocercas.vue'),
        AltaGeocerca: () => import('./components/Geocercas/NuevaGeocerca.vue'),
        ModificarGeocerca: () => import('./components/Geocercas/ModificarGeocerca.vue'),
        EliminarGeocerca: () => import('./components/Geocercas/EliminarGeocerca.vue'),

        MostrarDatosDispositivos: () => import('./components/Dispositivos/MostrarDatosDispositivos.vue'),
        ColoresEstadoDispositivo: () => import('./components/Dispositivos/ColoresEstadoDispositivo.vue'),

        UbicacionActualUsuario: () => import('./components/Ubicaciones/UbicacionActualUsuario.vue'),

        ProyeccionMovimiento: () => import('./components/Historico/ProyeccionMovimiento.vue'),
        DispositivosRedonda: () => import('./components/Historico/DispositivosRedonda.vue'),

        Grupos: () => import('./components/Grupos.vue'),

        NivelesUsuarios: () => import('./components/NivelesUsuarios.vue'),

        Bitacora: () => import('./components/Bitacora.vue'),

        Configuraciones: () => import('./components/Configuraciones.vue'),
    },
    data() {
        return {
            aciquiLogo: aciquiLogo,
            userRole: 'Usuario final',
            theme: 'light',
            isMenuOpen: false,
            currentView: 'Introduccion',
            openGroups: [],
            menuCompleto: [
                {
                    title: 'Empezando',
                    items: [
                        { id: 'Introduccion', title: 'Introducción', roles: ['Master', 'Administrador', 'Usuario final'] },
                        { id: 'Instalacion', title: 'Instalación', roles: ['Master', 'Administrador', 'Usuario final'] },
                    ]
                },
                {
                    title: 'Funcionalidades',
                    items: [
                        {
                            id: 'Session', title: 'Manejo de sesión', roles: ['Master', 'Administrador', 'Usuario final'],
                            children: [
                                { id: 'Login', title: 'Iniciar sesión' },
                                { id: 'Logout', title: 'Cierre de sesión' },
                            ]
                        },
                        {
                            id: 'ModuloMonitoreo', title: 'Monitoreo', roles: ['Master', 'Administrador', 'Usuario final'],
                            children: [
                                { id: 'Monitoreo', title: 'Monitoreo' },
                                { id: 'VerDispositivo', title: 'Ver dispositivo' },
                                { id: 'VerGeocerca', title: 'Ver Geocercas' },
                                { id: 'dispAlaRedonda', title: 'Disp. A la redonda' },
                            ]
                        },
                        {
                            id: 'ModuloUsuarios', title: 'Usuarios', roles: ['Master', 'Administrador'],
                            children: [
                                { id: 'usuarios', title: 'Usuarios' },
                                { id: 'altaUsuario', title: 'Alta de usuario' },
                                { id: 'EditarUsuario', title: 'Editar Usuario' },
                                { id: 'EstatusUsuario', title: 'Estatus usuario' },
                                { id: 'RestablecerContraseña', title: 'Restablecer contraseña' },
                                { id: 'CerrarSesion', title: 'Cerrar sesión usuario' },
                            ]
                        },
                        {
                            id: 'ModuloDispositivos', title: 'Dispositivos', roles: ['Master', 'Administrador'],
                            children: [
                                { id: 'Dispositivos', title: 'Dispositivos' },
                                { id: 'altaDispositivo', title: 'Alta de Dispositivo' },
                                { id: 'EditarDispositivo', title: 'Editar Dispositivo' },
                                { id: 'EliminarDispositivo', title: 'Eliminar Dispositivo' },
                                { id: 'CompartirLink', title: 'Compartir Link' },
                            ]
                        },
                        {
                            id: 'ModuloUbicaciones', title: 'Ubicaciones', roles: ['Master', 'Administrador', 'Usuario final'],
                            children: [
                                { id: 'Ubicaciones', title: 'Ubicaciones' },
                                { id: 'altaUbicacion', title: 'Agregar Ubicación' },
                                { id: 'VerUbicaciones', title: 'Ver ubicaciones' },
                                { id: 'EditarUbicacion', title: 'Editar ubicacion' },
                                { id: 'EliminarUbicacion', title: 'Eliminar ubicacion' },
                            ]
                        },
                        {
                            id: 'ModuloNotificaciones', title: 'Notificaciones', roles: ['Master', 'Administrador', 'Usuario final'],
                            children: [
                                { id: 'Notificaciones', title: 'Notificaciones' },
                                { id: 'Alertas', title: 'Alertas' },
                                { id: 'AlarmaAudible', title: 'Alarma audible' },
                            ]
                        },

                        {
                            id: 'Geocercas',
                            title: 'Geocercas',roles: ['Master', 'Administrador', 'Usuario final'],
                            children: [
                                { id: 'AdminGeocerca', title: 'Administración Geocercas' },
                                { id: 'BusquedaGeocerca', title: 'Realizar Búsqueda' },
                                { id: 'AltaGeocerca', title: 'Nueva Geocerca' },
                                { id: 'ModificarGeocerca', title: 'Modificar Geocerca' },
                                { id: 'EliminarGeocerca', title: 'Eliminar Geocerca' }
                            ]
                        },
                        { id: 'MostrarDatosDispositivos', title: 'Datos del dispostivo',roles: ['Master', 'Administrador', 'Usuario final'], },
                        { id: 'ColoresEstadoDispositivo', title: 'Colores por estado',roles: ['Master', 'Administrador', 'Usuario final'], },
                        { id: 'UbicacionActualUsuario', title: 'Ubicación del usuario',roles: ['Master', 'Administrador', 'Usuario final'], },
                        {
                            id: 'HistoricoDispositivo', title: 'Historico de un dispositivo',roles: ['Master', 'Administrador', 'Usuario final'],
                            children: [
                                { id: 'ProyeccionMovimiento', title: 'Proyección de Movimiento' },
                                { id: 'DispositivosRedonda', title: 'Dispositivos a la redonda' }
                            ]
                        },
                        { id: 'Grupos', title: 'Grupos',roles: ['Master', 'Administrador'] },
                        { id: 'NivelesUsuarios', title: 'Niveles de Usuarios',roles: ['Master', 'Administrador'] },
                        { id: 'Configuraciones', title: 'Configuraciones',roles: ['Master'] },
                        { id: 'Bitacora', title: 'Bitácora',roles: ['Master'] },

                    ]
                }
            ],
        };
    },
    computed: {
        // FILTRADO DINÁMICO POR ROL
        estructuraMenu() {
            if (!this.userRole) return [];

            const rolUsuario = this.userRole.toLowerCase(); // Convertimos el rol actual a minúsculas

            return this.menuCompleto.map(group => {
                const itemsFiltrados = group.items.filter(item => {
                    // Convertimos cada rol de la lista a minúsculas para comparar
                    return item.roles && item.roles.some(r => r.toLowerCase() === rolUsuario);
                });
                return { ...group, items: itemsFiltrados };
            }).filter(group => group.items.length > 0);
        },

        // Lista plana para navegación de DocPagination
        docOrder() {
            return this.estructuraMenu.flatMap(group =>
                group.items.flatMap(item => item.children ? item.children : item)
            );
        },
        // Mapeo de ID -> Título para Breadcrumbs
        sectionTitles() {
            const titles = {};
            // Agregamos un fallback para 'Introduccion' que siempre existe
            titles['Introduccion'] = 'Introducción';

            if (this.docOrder) {
                this.docOrder.forEach(item => {
                    titles[item.id] = item.title;
                });
            }
            return titles;
        }
    },
    methods: {
        toggleTheme() {
            this.theme = this.theme === 'light' ? 'dark' : 'light';
            localStorage.setItem('aciqui-theme', this.theme);
        },
        // Alterna abrir/cerrar manualmente
        toggleGroup(id) {
            if (this.openGroups.includes(id)) {
                this.openGroups = this.openGroups.filter(g => g !== id);
            } else {
                this.openGroups.push(id);
            }
        },
        // Verifica si la vista actual pertenece a un grupo y lo abre
        checkActiveGroup() {
            this.estructuraMenu.forEach(group => {
                group.items.forEach(item => {
                    if (item.children) {
                        const hasActiveChild = item.children.some(sub => sub.id === this.currentView);
                        if (hasActiveChild && !this.openGroups.includes(item.id)) {
                            this.openGroups.push(item.id);
                        }
                    }
                });
            });
        },
        navigate(viewId) {
            // Verificamos si el componente existe en la definición de la data
            this.currentView = viewId;
            localStorage.setItem('aciqui-last-view', viewId);
            this.isMenuOpen = false;
            this.checkActiveGroup();
            this.$nextTick(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        },
        limpiarSesionDocumentacion() {
            // Borramos solo lo relacionado con la documentación
            localStorage.removeItem('aciqui-last-view');
        },
        irHome(){
            this.$router.push("/monitoreo");
        }
    },
    created() {
        // 1. Cargar Tema
        const savedTheme = localStorage.getItem('aciqui-theme');
        if (savedTheme) this.theme = savedTheme;

        // 2. Cargar Rol (Asegúrate que el string coincida: 'Master', 'Administrador', 'Usuario final')
        const savedRole = sessionStorage.getItem('rol');
        if (savedRole) this.userRole = savedRole;

        // 3. Cargar y Validar Vista
        const lastView = localStorage.getItem('aciqui-last-view');

        // Validación manual segura: Buscamos en el menú original si el ID existe y si el rol coincide
        let vistaValida = false;

        this.menuCompleto.forEach(group => {
            group.items.forEach(item => {
                // Verificar si el item (padre) tiene el rol
                if (item.roles.includes(this.userRole)) {
                    // Si es el item buscado
                    if (item.id === lastView) vistaValida = true;
                    // O si es uno de sus hijos
                    if (item.children) {
                        if (item.children.some(child => child.id === lastView)) vistaValida = true;
                    }
                }
            });
        });

        if (lastView && vistaValida) {
            this.currentView = lastView;
        } else {
            this.currentView = 'Introduccion';
            localStorage.setItem('aciqui-last-view', 'Introduccion');
        }

        this.checkActiveGroup();
    },
    beforeDestroy() {
        this.limpiarSesionDocumentacion();
    },
};
</script>

<style scoped>
/* transición suave al cambiar de contenido */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}


/* Estenedor del título para que sea clickeable */
.nav-subtitle-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    min-height: 40px;
    box-sizing: border-box;
}

.nav-subtitle-container:hover {
    background: var(--code-bg);
    color: var(--primary-color);
}

.nav-subtitle-container.is-expanded .nav-subtitle,
.nav-subtitle-container.is-expanded .chevron {
    color: var(--primary-color);
}

.chevron {
    font-size: 0.7rem;
    opacity: 0.6;
}

/* Transición de deslizamiento */
.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s ease;
    max-height: 500px;
    /* Un valor alto suficiente */
    overflow: hidden;
}

.slide-enter,
.slide-leave-to {
    max-height: 0;
    opacity: 0;
}

.sub-nav {
    padding-left: 15px;
    border-left: 2px solid #eee;
    margin-left: 10px;
}
</style>